import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "./quotaModificationUtils";
import { saveAs } from "file-saver";
const initialState = {
	isLoading: false,

	quotaStatusList: [],
	selectedQuotaStatus: "All except Approved/Rejected",

	countries: [],
	selectedCountry: "All",
	selectedCountryID: "0",

	navigatedCountryID: "",

	selectedPeriod: "1",

	quotaList: [],

	popupGraphData: null,
	graphModalOpen: false,

	selectedRows: [],
	selectedRowsselected: [],
	scenarioModificationList: null,

	displayModifiedRecords: true,
	scenarioName: "",
	rejectSelModalOpen: false,
	rejectSelectedComment: "",
	files: [],
	filepaths: [],
	searchText: "",
	appWithCommentModal: false,
	appWithComment: "",
	scenarioCanApproveReject: false,
	selectedScenarioCanEdit: false,
	rejectScenarioModalSingleOpen: false,
	selectedModificationid: 0,
	appWithCommentModalSingle: false,
	isButtonClicked: false,
	selectedModificationNumber: "",
	message: "",
	severity: "",
	messageOpen: false,
	expandedRowIndex: null,

	redirectedFromDashboard: false,
	modificationCustomersPriorChanges : [],
	modificationCustomersLatestChanges : [],
	periodType: ""
};

export const getQuotaStatusList = createAsyncThunk(
	"quotaModification/getQuotaStatusList",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.quotaStatus;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quotaModification/getQuotaStatusList", error);
		}
	}
);

export const getUserCountries = createAsyncThunk(
	"quotaModification/getUserCountries",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.userCountries + `userid=${data.userID}`;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quota/getUserCountries", error);
		}
	}
);

export const getQuotaForApproval = createAsyncThunk(
	"quotaModification/getQuotaForApproval",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.quotaForApproval + `UserRoleID=${data.roleID}`;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quota/getQuotaForApproval", error);
		}
	}
);

export const getPopupGraphData = createAsyncThunk(
	"quotaModification/getPopupGraphData",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const { scenarioID } = obj;
			const url = urls.popupGraph + `scenarioID=${scenarioID}`;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quota/getPopupGraphData", error);
		}
	}
);

export const getScenarioModificationList = createAsyncThunk(
	"quotaModification/getScenarioModificationList",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const { CountryID, QuotaID } = obj;
			const url =
				urls.scenarioModificationList +
				`CountryID=${CountryID}&QuotaID=${QuotaID}`;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quota/getScenarioModificationList", error);
		}
	}
);
export const getScenarioModificationListPerModId = createAsyncThunk(
	"quotaModification/getScenarioModificationListPerModId",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const { CountryID, QuotaID, ModId } = obj;
			const url =
				urls.scenarioModificationList +
				`CountryID=${CountryID}&QuotaID=${QuotaID}&ModId=${ModId}`;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quota/getScenarioModificationListPerModId", error);
		}
	}
);
export const Upload = createAsyncThunk(
	"quotaModification/Upload",
	async (obj, { dispatch, getState }) => {
		const { files } = getState().quotaModification;
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const formData = new FormData();
		for (var i = 0; i < files.length; i++) {
			formData.append("files", files[i], files[i].name);
		}
		const url = urls.Upload;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
					"Content-Disposition": "multipart/form-data",
				},
				body: formData,
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const rejectMultiple = createAsyncThunk(
	"quotamodification/rejectMultiple",
	async (obj, { dispatch, getState }) => {
		try {
			const { filepaths } = getState().quotaModification;
			let objselected = JSON.parse(JSON.stringify(obj));
			if (
				filepaths !== undefined &&
				filepaths != null &&
				filepaths.length > 0
			) {
				for (let i = 0; i < obj.length; i++) {
					objselected[i]["listModificationFiles"] = [];
					objselected[i]["listModificationFiles"] = filepaths;
				}
			}
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url =
				urls.rejectMultiple +
				`isCountryApprover=${data.isLocalUser && data.isApprover}`;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
				body: JSON.stringify(objselected),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quotamodification/rejectMultiple", error);
		}
	}
);

export const rejectModificationSingle = createAsyncThunk(
	"quotamodification/rejectModificationSingle",
	async (formData, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.rejectSingle;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Disposition": "multipart/form-data",
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
				body: formData,
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quotamodification/rejectModificationSingle", error);
		}
	}
);
export const approveModificationSingle = createAsyncThunk(
	"quotaModification/approveModificationSingle",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveSingle;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quotaModification/approveModificationSingle", error);
		}
	}
);

export const approveModificationSingleComments = createAsyncThunk(
	"quotaModification/approveModificationSingleComments",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveSingleWithComment;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error(
				"quotaModification/approveModificationSingleComments",
				error
			);
		}
	}
);

export const approveQuota = createAsyncThunk(
	"quotamodification/approveModification",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url =
				urls.approve +
				`isCountryApprover=${data.isLocalUser && data.isApprover}`;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quotamodification/approveQuota", error);
		}
	}
);
export const approveMultipleWithComment = createAsyncThunk(
	"quotamodification/approveMultipleWithComment",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url =
				urls.approveMulWithComment +
				`isCountryApprover=${data.isLocalUser && data.isApprover}`;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("quotamodification/approveMultipleWithComment", error);
		}
	}
);
export const DownloadFile = createAsyncThunk(
	"define/downloadfile",
	async (filepath, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = urls.Downloadfile + `fileName=${filepath}`;
		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const res = await response.blob();
			const fileName = filepath;
			saveAs(res, fileName);
			return res;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

const quotaModificationApprovalSlice = createSlice({
	name: "quotaModification",
	initialState,
	reducers: {
		setState: {
			prepare(name, value) {
				return {
					payload: { name, value },
				};
			},
			reducer(state, action) {
				const { name, value } = action.payload;
				state[name] = value;
			},
		},
		reset(state, { payload }) {
			if (payload === "refresh") {
				state.selectedQuotaStatus = "All except Approved/Rejected";
				if (!state.redirectedFromDashboard) {
					state.selectedCountry = "All";
					state.selectedCountryID = "0";
				}

				state.selectedPeriod = "1";
				state.quotaList = [];
				state.popupGraphData = null;
				state.graphModalOpen = false;
				state.electedRows = [];
				state.selectedRowsselected = [];
				state.scenarioModificationList = null;
				state.displayModifiedRecords = true;
				state.scenarioName = "";
				state.rejectSelModalOpen = false;
				state.rejectSelectedComment = "";
				state.files = [];
				state.filepaths = [];
				state.searchText = "";
				state.appWithCommentModal = false;
				state.appWithComment = "";
				state.scenarioCanApproveReject = false;
				state.selectedScenarioCanEdit = false;
				state.rejectScenarioModalSingleOpen = false;
				state.selectedModificationid = 0;
				state.appWithCommentModalSingle = false;
				state.isButtonClicked = false;
				state.selectedModificationNumber = "";
				state.message = "";
				state.severity = "";
				state.messageOpen = false;
				state.expandedRowIndex = null;
        state.redirectedFromDashboard = false;
			}
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getQuotaStatusList.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getQuotaStatusList.fulfilled, (state, action) => {
				state.quotaStatusList = action.payload;
				state.isLoading = false;
			})
			.addCase(getQuotaStatusList.rejected, (state, action) => {
				console.error(
					"quotaModification/getQuotaStatusList",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getUserCountries.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getUserCountries.fulfilled, (state, action) => {
				state.countries = action.payload;
				state.isLoading = false;
			})
			.addCase(getUserCountries.rejected, (state, action) => {
				console.error(
					"quotaModification/getUserCountries",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getQuotaForApproval.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getQuotaForApproval.fulfilled, (state, action) => {
				state.quotaList = action.payload;
				state.isLoading = false;
				if (state.quotaList?.length === 0) {
					state.messageOpen = true;
					state.message = "No Records Found";
					state.severity = "info";
				}
			})
			.addCase(getQuotaForApproval.rejected, (state, action) => {
				console.error(
					"quotaModification/getQuotaForApproval",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getPopupGraphData.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getPopupGraphData.fulfilled, (state, action) => {
				state.popupGraphData = action.payload.approvalDataChartDataBOList;
				state.isLoading = false;
			})
			.addCase(getPopupGraphData.rejected, (state, action) => {
				console.error(
					"quotaModification/getPopupGraphData",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getScenarioModificationList.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getScenarioModificationList.fulfilled, (state, action) => {
				state.scenarioModificationList = action.payload;
				state.modificationCustomersPriorChanges = action.payload[0].modificationCustomersPriorChanges;
				state.modificationCustomersLatestChanges = action.payload[0].modificationCustomersLatestChanges;
				state.isLoading = false;
			})
			.addCase(getScenarioModificationList.rejected, (state, action) => {
				console.error(
					"quotaModification/getScenarioModificationList",
					action.error.message
				);
				state.isLoading = false;
			})
			.addCase(getScenarioModificationListPerModId.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getScenarioModificationListPerModId.fulfilled, (state, action) => {
				state.modificationCustomersPriorChanges = action.payload[0].modificationCustomersPriorChanges;
				state.modificationCustomersLatestChanges = action.payload[0].modificationCustomersLatestChanges;
				state.isLoading = false;
			})
			.addCase(getScenarioModificationListPerModId.rejected, (state, action) => {
				console.error(
					"quotaModification/getScenarioModificationListPerModId",
					action.error.message
				);
				state.isLoading = false;
			})
			.addCase(Upload.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(Upload.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.filepaths = payload;
				state.files = [];
			})
			.addCase(Upload.rejected, (state, action) => {
				state.isLoading = false;
			})
			.addCase(rejectMultiple.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(rejectMultiple.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload === true) {
					state.messageOpen = true;
					state.message = "Selected Modifications Rejected Successfully";
					state.severity = "success";
				} else {
					state.messageOpen = true;
					state.message = "Selected Modifications Reject Failed";
					state.severity = "error";
				}
			})
			.addCase(rejectMultiple.rejected, (state, action) => {
				console.error("quotamodification/rejectMultiple", action.error.message);
				state.isLoading = false;
				state.messageOpen = true;
				state.message = "Selected Modifications Reject Failed";
				state.severity = "error";
			})
			.addCase(approveQuota.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveQuota.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload === true) {
					state.messageOpen = true;
					state.message = "Selected Modifications Approved Successfully";
					state.severity = "success";
				} else {
					state.messageOpen = true;
					state.message = "Selected Modifications Approval Failed";
					state.severity = "error";
				}
			})
			.addCase(approveQuota.rejected, (state, action) => {
				console.error(
					"quotamodification/approveModification",
					action.error.message
				);
				state.isLoading = false;
				state.messageOpen = true;
				state.message = "Selected Modification Approval Failed";
				state.severity = "error";
			})
			.addCase(approveMultipleWithComment.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveMultipleWithComment.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload === true) {
					state.messageOpen = true;
					state.message = "Selected Modifications Approved Successfully";
					state.severity = "success";
				} else {
					state.messageOpen = true;
					state.message = "Selected Modifications Approve Failed";
					state.severity = "error";
				}
			})
			.addCase(approveMultipleWithComment.rejected, (state, action) => {
				console.error("quota/approveMultipleWithComment", action.error.message);
				state.isLoading = false;
				state.messageOpen = true;
				state.message = "Selected Modifications Approve Failed";
				state.severity = "error";
			})
			.addCase(rejectModificationSingle.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(rejectModificationSingle.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload === true) {
					state.messageOpen = true;
					state.message = "Modification Rejected Successfully";
					state.severity = "success";
				} else {
					state.messageOpen = true;
					state.message = "Modification Rejection Failed";
					state.severity = "error";
				}
			})
			.addCase(rejectModificationSingle.rejected, (state, action) => {
				console.error("quota/rejectModificationSingle", action.error.message);
				state.isLoading = false;
				state.messageOpen = true;
				state.message = "Modification Rejection Failed";
				state.severity = "error";
			})
			.addCase(approveModificationSingle.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveModificationSingle.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload === true) {
					state.messageOpen = true;
					state.message = "Modification Approved Successfully";
					state.severity = "success";
				} else {
					state.messageOpen = true;
					state.message = "Modification Approve Failed";
					state.severity = "error";
				}
			})
			.addCase(approveModificationSingle.rejected, (state, action) => {
				console.error("quota/approveModificationSingle", action.error.message);
				state.isLoading = false;
				state.messageOpen = true;
				state.message = "Modification Approve Failed";
				state.severity = "error";
			})
			.addCase(approveModificationSingleComments.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveModificationSingleComments.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload === true) {
					state.messageOpen = true;
					state.message = "Modification Approved Successfully";
					state.severity = "success";
				} else {
					state.messageOpen = true;
					state.message = "Modification Approve Failed";
					state.severity = "error";
				}
			})
			.addCase(approveModificationSingleComments.rejected, (state, action) => {
				console.error(
					"quota/approveModificationSingleComments",
					action.error.message
				);
				state.isLoading = false;
				state.messageOpen = true;
				state.message = "Modification Approve Failed";
				state.severity = "error";
			});
	},
});

export const { setState, reset } = quotaModificationApprovalSlice.actions;
export default quotaModificationApprovalSlice.reducer;
